import { useEffect, useState } from 'react';
import usePermissions from './hooks/usePermissions';
import { useCurrentUserProfile } from './hooks/user';
import { syncLanguageWithBackend } from './i18n';

function useGlobalPermissions() {
  const { data, isLoading: userProfileLoading } = useCurrentUserProfile();
  const { permissions: featurePermissions } = usePermissions('feature');
  const { permissions: dataPermissions } = usePermissions('data_access');

  const [userData, setUserData] = useState(() => JSON.parse(localStorage.getItem('permissions')));
  const [permissionsLoaded, setPermissionsLoaded] = useState(false);

  useEffect(() => {
    if (!userProfileLoading && data) {
      setUserData(data);
      localStorage.setItem('permissions', JSON.stringify(data));

      if (data.data?.app_language) {
        syncLanguageWithBackend(data.data.app_language);
      }
    }
  }, [data, userProfileLoading]);

  const [dataAccessPermissions, setDataAccessPermissions] = useState({
    people: false,
    pay: false,
  });

  const [moduleAccessPermissions, setModuleAccessPermissions] = useState({
    Overview: false,
    'Custom Dashboard': false,
    'Data Extractor': false,
    PeopleHubEmployees: false,
    PeopleHubPayroll: false,
    'Advanced Analytics': false,
    'Data Management': false,
    sam: false,
    BDESE: false,
    IndexMW: false,
  });

  useEffect(() => {
    if (featurePermissions?.length) {
      const allFeaturePermissions = featurePermissions?.filter(
        (permission) => permission.permission_value === 'ALL'
      );
      const allDataPermissions = dataPermissions?.filter(
        (permission) => permission.permission_value === 'ALL'
      );

      if (allFeaturePermissions?.length > 0) {
        setModuleAccessPermissions({
          Overview: true,
          'Custom Dashboard': true,
          'Data Extractor': true,
          'Advanced Analytics': true,
          'Data Management': true,
          PeopleHubEmployees: true,
          PeopleHubPayroll: true,
          sam: true,
          BDESE: true,
          IndexMW: true,
        });
      } else {
        const moduleAccess = featurePermissions.reduce((acc, permission) => {
          return {
            ...acc,
            [permission.permission_value]: true,
          };
        }, {});

        setModuleAccessPermissions(moduleAccess);
      }

      if (allDataPermissions?.length > 0) {
        setDataAccessPermissions({
          people: true,
          pay: true,
        });
      } else {
        const dataAccess = Object.keys(dataAccessPermissions).reduce(
          (acc, permission) => ({
            ...acc,
            [permission]: dataPermissions?.some((perm) => perm.permission_value === permission),
          }),
          {}
        );

        setDataAccessPermissions(dataAccess);
      }

      setPermissionsLoaded(true);
    }
  }, [userData, featurePermissions, dataPermissions]);

  return {
    userData,
    userProfileLoading,
    dataAccessPermissions,
    moduleAccessPermissions,
    permissionsLoaded,
  };
}

export default useGlobalPermissions;
